import React, {useEffect} from 'react';
import {Divider, Flex, Form, Input, Tag} from "antd";
import IntlMessage from "../../../../../components/IntlMessage/IntlMessage";
import {useDispatch, useSelector} from "react-redux";
import {changeCurrentPage} from "../../../../../store/slices/tableController/StudentsListTableController";
import {getAllStudentsPageable} from "../../../../../store/slices/StudentsListSlice";
import MyTable from "../../../../../components/Table/MyTable";
import classes from "../../Applications/application.module.css";
import {LocalName} from "../../../../../utils/LocalName";

const StudentsList = () => {
    const dispatch = useDispatch();
    const {students, isLoading, hasMore, error} = useSelector(state => state.studentsList)
    const {currentPage, pageSize} = useSelector(state => state.studentsListTableController);

    const [filterForm] = Form.useForm();
    const name = Form.useWatch('name', filterForm);

    useEffect(() => {
        dispatch(getAllStudentsPageable({
            page: currentPage,
            limit: pageSize,
            name: name || "",
            isGroupsNeeded: true
        }));
    }, []);

    const fetchData = async (params) => {
        return dispatch(getAllStudentsPageable({
            ...params,
            name: name || "",
            isGroupsNeeded: true
        }));
    }

    const saveCurrentPageSettings = (page, pageSize) => {
        dispatch(changeCurrentPage({page: page, pageSize: pageSize}));
    };

    const columns = [
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'fullName'}/> / <IntlMessage
                id={'username'}/></span>,
            render: (_, record) => (
                <p>{record.fullName}</p>
            ),
            width: '30%',
        },
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'email'}/></span>,
            render: (_, record) => (
                <p>{record.email}</p>
            ),
            width: '25%',
        },
        {
            title: <span style={{fontWeight: 600}}><IntlMessage id={'groups'}/></span>,
            render: (_, record) => (
                <Flex gap={5} wrap="wrap">
                    {record.groups && record.groups.length > 0 ? (
                        record.groups.map((group, index) => (
                            <Tag key={index} color="blue">
                                {LocalName.getName(group)} {group.number}
                            </Tag>
                        ))
                    ) : (
                        <Tag color="orange"><IntlMessage id={'noGroups'}/></Tag>
                    )}
                </Flex>
            ),
            width: '45%',
        },
    ];

    return (
        <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} vertical gap={20}>
            <Form style={{width: "100%"}} onKeyUp={(e) => {
                if (e.key === "Enter") {
                    dispatch(getAllStudentsPageable({
                        page: currentPage,
                        limit: pageSize,
                        name: name || "",
                        isGroupsNeeded: true
                    }))
                }
            }} form={filterForm} className={classes.form}>
                <Flex style={{width: "100%"}} align={"flex-start"} justify={"flex-start"} gap={20}>
                    <Flex style={{width: "50%"}} vertical align={"flex-start"} justify={"flex-start"}>
                        <Divider className={classes.divider} orientation="left">
                            <IntlMessage id={'fullName'}/>
                        </Divider>
                        <Form.Item name="name" className={classes.formInputBlock}>
                            <Input className={classes.formInput} placeholder={"Азамат Амангелдиев"}/>
                        </Form.Item>
                    </Flex>
                </Flex>
            </Form>
            <MyTable
                isLoading={isLoading}
                dataSource={students}
                columns={columns}
                fetchData={fetchData}
                saveCurrentPage={saveCurrentPageSettings}
                initialPage={currentPage}
                initialPageSize={pageSize}
                hasMore={hasMore}
            />
        </Flex>
    );
};

export default StudentsList;